module.exports = __webpack_public_path__ + "img/popupAd-day3.c7a32ff3.png";